import React from "react";

import { useTranslation } from "react-i18next";

import { BetSlipTypes } from "@gp/models";
import { BetSlipBetType } from "@gp/slip";
import BetSlipStore from "@state/bet-slip/BetSlipStore";
import { observer } from "mobx-react";

export default observer(function BetSlipTypeSelector(props: {
	store: BetSlipStore;
}) {
	const { t } = useTranslation();

	return (
		<nav className="slip__nav">
			<ul className="slip__tabs tabs--tertiary">
				<li className="slip__tabs__item tabs--tertiary__item">
					<button
						disabled={props.store.isSubmitting}
						onClick={(e) => {
							props.store.onBetSlipTypeChange(
								BetSlipTypes.COMBINATION
							);
							if (
								props.store.betSlipBetType ===
								BetSlipBetType.OneClickBet
							) {
								props.store.onSwitchFromOneClickBet(
									BetSlipTypes.COMBINATION
								);
							}
						}}
						className={
							"slip__tabs__link tabs--tertiary__link" +
							(props.store.betSlipType ===
								BetSlipTypes.COMBINATION &&
							props.store.betSlipBetType === BetSlipBetType.Normal
								? " is-active"
								: "")
						}
					>
						{t<string>("BET_SLIP.TYPE.COMBINATION")}
					</button>
				</li>
				<li className="slip__tabs__item tabs--tertiary__item">
					<button
						onClick={(e) => {
							props.store.onBetSlipTypeChange(
								BetSlipTypes.SYSTEM
							);
							if (
								props.store.betSlipBetType ===
								BetSlipBetType.OneClickBet
							) {
								props.store.onSwitchFromOneClickBet(
									BetSlipTypes.SYSTEM
								);
							}
						}}
						className={
							"slip__tabs__link tabs--tertiary__link" +
							(props.store.betSlipType === BetSlipTypes.SYSTEM &&
							props.store.betSlipBetType === BetSlipBetType.Normal
								? " is-active"
								: "")
						}
						disabled={
							props.store.betSlipState.isMultiOfferPresent ||
							props.store.isSubmitting ||
                            !!props.store.betSlipState.freebetId 
						}
					>
						{t<string>("BET_SLIP.TYPE.SYSTEM")}
					</button>
				</li>
				<li className="slip__tabs__item tabs--tertiary__item">
					<button
						disabled={props.store.isSubmitting || !!props.store.betSlipState.freebetId}
						onClick={(e) => {
							props.store.changeBetSlipBetType(
								BetSlipBetType.OneClickBet
							);
						}}
						className={
							`slip__tabs__link tabs--tertiary__link` +
							(props.store.betSlipBetType ===
							BetSlipBetType.OneClickBet
								? " is-active"
								: "")
						}
					>
						{t<string>("BET_SLIP.ONE_CLICK_BET.LABEL")}
					</button>
				</li>
			</ul>
		</nav>
	);
});
